import React, { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { startOfYear, subYears } from 'date-fns'
import styled from 'styled-components'

import { LoadingIndicator } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/LoadingIndicator'
import { PlatformEngagementQuarterlyDetails } from '@lyrahealth-inc/ui-core-crossplatform/src/pages/platformEngagementQuarterlyDetails/PlatformEngagementQuarterlyDetails'

import { usePlatformEngagementMetricsData } from './hooks/usePlatformEngagementMetricsData'
import useTransformPEMetrics from './hooks/useTransformPEMetrics'
import { actions as mixpanelActions, mixpanelEvents } from '../../../../../mixpanel/mixpanelConstants'
import { track } from '../../../../../mixpanel/mixpanelTracking'
import { BC_PLATFORM_ENGAGEMENT } from '../../../common/constants/routingConstants'

const Container = styled.div({
  display: 'flex',
  justifyContent: 'center',
})

const PlatformEngagementQuarterlyDetailsContainer: React.FunctionComponent = () => {
  const navigate = useNavigate()
  const onBackPressed = useCallback(() => {
    track({
      event: mixpanelEvents.BUTTON_PRESS,
      action: mixpanelActions.BACK,
    })
    navigate(BC_PLATFORM_ENGAGEMENT.route)
  }, [navigate])
  const onCurrentYearPressed = useCallback((isExpanded) => {
    track({
      event: mixpanelEvents.BUTTON_PRESS,
      action: mixpanelActions.CURRENT_YEAR,
      details: isExpanded ? 'Open' : 'Close',
    })
  }, [])

  const { data: currentYearMetrics, isLoading: isLoadingCurr } = usePlatformEngagementMetricsData()
  const { data: previousYearMetrics, isLoading: isLoadingPrev } = usePlatformEngagementMetricsData({
    previousYear: true,
  })
  const currentMetrics = useTransformPEMetrics(currentYearMetrics)
  const prevMetrics = useTransformPEMetrics(previousYearMetrics, true)

  const onPreviousYearPressed = useCallback((isExpanded) => {
    track({
      event: mixpanelEvents.BUTTON_PRESS,
      action: mixpanelActions.PREVIOUS_YEAR,
      details: isExpanded ? 'Open' : 'Close',
    })
  }, [])

  const loadingMetrics = isLoadingCurr || isLoadingPrev
  const fetchedMetrics = currentMetrics && prevMetrics
  return (
    <Container>
      {loadingMetrics && !fetchedMetrics ? (
        <LoadingIndicator topPadding={24} />
      ) : (
        <PlatformEngagementQuarterlyDetails
          currentYear={startOfYear(new Date()).getUTCFullYear()}
          previousYear={subYears(startOfYear(new Date()), 1).getUTCFullYear()}
          currentYearMetrics={currentMetrics}
          previousYearMetrics={prevMetrics}
          onBackPressed={onBackPressed}
          onCurrentYearPressed={onCurrentYearPressed}
          onPreviousYearPressed={onPreviousYearPressed}
        />
      )}
    </Container>
  )
}

export default PlatformEngagementQuarterlyDetailsContainer
